import React from 'react'

function Footer() {
  return (
    <>
        <footer className="footer">
            <div className="container-fluid">
                <div className="row text-muted">
                    <div className="col-12 text-end">
                        <ul className="list-inline">
                            <li className="list-inline-item">
                                Designed by <a className="text-muted" href="#">VMax</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export default Footer
